<template>
  <div class="card noti-header">
    <div class="noti-wrapper d-flex align-items-center justify-content-between">
      <h6>Mobile Push Notifications</h6>
      <div class="active-switch">
        <label class="switch">
          <input type="checkbox" checked />
          <span class="sliders round"></span>
        </label>
      </div>
    </div>
    <div class="noti-wrapper d-flex align-items-center justify-content-between">
      <h6>Desktop Notifications</h6>
      <div class="active-switch">
        <label class="switch">
          <input type="checkbox" checked />
          <span class="sliders round"></span>
        </label>
      </div>
    </div>
    <div class="noti-wrapper d-flex align-items-center justify-content-between">
      <h6>Email Notifications</h6>
      <div class="active-switch">
        <label class="switch">
          <input type="checkbox" checked />
          <span class="sliders round"></span>
        </label>
      </div>
    </div>
    <div class="noti-wrapper d-flex align-items-center justify-content-between mb-0">
      <h6>SMS Notification</h6>
      <div class="active-switch">
        <label class="switch">
          <input type="checkbox" checked />
          <span class="sliders round"></span>
        </label>
      </div>
    </div>
  </div>
</template>
